// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import 'bootstrap';
import '@coreui/coreui';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@coreui/coreui/dist/css/coreui.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@fortawesome/fontawesome-free/js/all.min.js';
import 'react-image-lightbox/style.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/react-hooks';

import client from './configure/createApolloClient';
import configureStore, { history } from './configure/configureStore';
import App from './App';
require('./configure/configureFontAwesome');

const store = configureStore();
const Root = () => {
  return (
    <Provider store={store}>
      <Router>
        <ApolloProvider client={client}>
          <App history={history} />
        </ApolloProvider>
      </Router>
    </Provider>
  );
};

const rootElement = document.getElementById('root');
ReactDOM.render(<Root />, rootElement);
